// extracted by mini-css-extract-plugin
export default {"wrapper":"TranslatorPage_wrapper__w6gRh","wrapper2":"TranslatorPage_wrapper2__C1y1f","wrapper3":"TranslatorPage_wrapper3__kT+WE"};